import React from "react";
import Modal from "antd/es/modal/Modal";
import "./ImportantAlert.less";
import Utils from "../../utils/Utils";
import {Button} from "antd";

class ImportantAlert extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
            loading: false
        }
    }

    onCancel = () => {
        this.props.onCancel()
    }
    onChange = () => {
        this.setState({
            checked: !this.state.checked
        })
    }

    onClick = () => {
        this.setState({
            loading: true
        })
        Utils.firstLogin(this.props.loginId, this.props.loginTid, (response) => {
            console.log(response)
            this.setState({
                loading: false
            })
            window.location.replace(this.props.redirect)
        })
    }

    render() {
        return (
            <Modal title={null}
                   visible={true}
                   footer={null}
                   maskClosable={false}
                   keyboard={false}
                   wrapClassName="important-alert"
                   onCancel={this.onCancel}
                   style={{
                       width: '610px'
                   }}
            >
                <div className="alert-content">
                    <div className="alert-title">【重要提醒】</div>
                    <div className="alert-text">根据中央网信办<a href="http://www.cac.gov.cn/2017-05/02/c_1120902760.htm" target="_blank" rel="noopener noreferrer">《互联网新闻信息服务管理规定》</a>及<a href="http://www.cac.gov.cn/2021-01/22/c_1612887880656609.htm" target="_blank" rel="noopener noreferrer">《互联网用户公众账号信息服务管理规定》</a>等法规的安全要求，请您在登录系统时验证手机号码及密码等安全信息，感谢您的支持!</div>
                    <div className="alert-checkbox">
                        <input type="checkbox" id="important-alert-checkbox" onChange={this.onChange}></input>
                        <span className="checkbox-faker"></span>
                        <label htmlFor="important-alert-checkbox">我已阅读提醒</label>
                    </div>
                    <div className="alert-button">
                        <Button className="btn" disabled={!this.state.checked} loading={this.state.loading} onClick={this.onClick}>下一步</Button>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default ImportantAlert